<template>
  <span class="tag tag-default" :class="quantitySpanClass(value)">
    {{ value.toFixed(2) }}
  </span>
</template>

<script>
export default {
  name: "value-tag",
  props: {
    value: Number,
  },
  methods: {
    quantitySpanClass(value) {
      switch (true) {
        case value < 100:
          return "bg-red bg-darken-2";
        case value < 500:
          return "bg-yellow bg-darken-3";
        case value < 1000:
          return "bg-warning bg-darken-3";
        case value <= 2000:
          return "bg-green bg-darken-1";
        case value > 2000:
          return "bg-purple bg-darken-1";
      }
      return "";
    },
  },
};
</script>